import {
  Cancel,
  ChangeCircle,
  CheckCircle,
  Delete,
  Edit,
  MoreVert,
} from '@mui/icons-material';
import {
  Badge,
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { AbsenceEntry, AbsenceStatus } from '~/data/absences/types';
import { useMenu } from '~/hooks/useMenu';

export type AbsenceActionsCellProps = {
  absenceId: string;
  absenceEntry: AbsenceEntry;
  onEditAbsence: (absenceId: string) => void;
  onDeleteAbsence: (absenceId: string) => void;
  onApprove: (absenceId: string) => void;
  onReject: (absenceId: string) => void;
  onRequestChange: (absenceId: string) => void;
  canApproveAbsence: boolean;
  disabled: boolean;
};

export const AbsenceActionsCell = (props: AbsenceActionsCellProps) => {
  const {
    absenceId,
    absenceEntry,
    onEditAbsence,
    onDeleteAbsence,
    onApprove,
    onRequestChange,
    onReject,
    canApproveAbsence,
    disabled,
  } = props;
  const { anchorEl, open, isOpen, close } = useMenu();

  const { t } = useTranslation();

  const approveActionsEnabled =
    canApproveAbsence && [AbsenceStatus.PROPOSED].includes(absenceEntry.status);

  return (
    <Box>
      <IconButton onClick={open} disabled={disabled} size="small">
        {approveActionsEnabled ? (
          <Badge variant={'dot'} color={'primary'}>
            <MoreVert fontSize="small" />
          </Badge>
        ) : (
          <MoreVert fontSize="small" />
        )}
      </IconButton>

      <Menu onClose={close} open={isOpen} anchorEl={anchorEl}>
        {approveActionsEnabled && (
          <MenuItem onClick={() => onApprove(absenceId)}>
            <ListItemIcon>
              <CheckCircle fontSize="small" color={'success'} />
            </ListItemIcon>
            <ListItemText>{t('approve')}</ListItemText>
          </MenuItem>
        )}
        {approveActionsEnabled && (
          <MenuItem onClick={() => onRequestChange(absenceId)}>
            <ListItemIcon>
              <ChangeCircle fontSize="small" color={'info'} />
            </ListItemIcon>
            <ListItemText>{t('label_change')}</ListItemText>
          </MenuItem>
        )}
        {approveActionsEnabled && (
          <MenuItem onClick={() => onReject(absenceId)}>
            <ListItemIcon>
              <Cancel fontSize="small" color={'error'} />
            </ListItemIcon>
            <ListItemText>{t('reject')}</ListItemText>
          </MenuItem>
        )}
        {approveActionsEnabled && <Divider />}

        <MenuItem onClick={() => onEditAbsence(absenceId)}>
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('edit')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => onDeleteAbsence(absenceId)}>
          <ListItemIcon>
            <Delete fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('delete')}</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
};
